"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
function mapFormer(project) {
    return operators_1.map(function (_a) {
        var v1 = _a[0], v2 = _a[1];
        return [project(v1), v2];
    });
}
exports.mapFormer = mapFormer;
function mapLatter(project) {
    return operators_1.map(function (_a) {
        var v1 = _a[0], v2 = _a[1];
        return [v1, project(v2)];
    });
}
exports.mapLatter = mapLatter;
